module.exports = __webpack_public_path__ + "static/media/DaysWorked6.5cae6f07.png";